import {API} from "./API";
import {Payment} from "../models/Payment";

export class PaymentsAPI extends API<Payment> {

	constructor () {
		super("payments");
	}

	getByCustomer (customerId: string) {

		let url = `/payments/customer/${customerId}`;
		return API.axiosInstance.get(url);
	}

}
